export default __webpack_public_path__ + "static/media/arjun.b79e4893.jpg";